import React, { FC } from 'react'
import classnames from 'classnames'
import { Text, csx } from '@vtex/admin-ui'
import { ItemSelectorProps } from '../typings'

const ItemSelector: FC<ItemSelectorProps> = ({
  selected,
  handleSelect,
  isAvailable,
  thumbSrc,
  label,
}) => {
  return (
    <div
      className={csx({
        '.sku-general-container': {
          position: 'relative',
          display: 'flex',
          alignItems: 'center',
          fontSize: '90%',
          marginBottom: '10px',
          marginRight: '10px',
          height: '42px',
        },
        'sku-thumb-container': {
          padding: '$space-0',
          height: '42px',
          width: '42px',
        },
        '.sku-container': {
          cursor: 'pointer',
          width: '100%',
          height: '100%',
          borderStyle: 'solid',
          borderWidth: '1px',
          borderRadius: '.25rem',
          zIndex: 1,
          display: 'flex',
          alignItems: 'center',
          overflow: 'hidden',
          position: 'relative',
        },
        '.sku-container-selected': {
          borderColor: '#134CD8',
          backgroundColor: '#DDE5F7',
          color: '#134CD8',
        },
        '.sku-container-not-selected': {
          borderColor: '#e3e4e6',
        },
        '.sku-available-action': {
          position: 'absolute',
          top: '$space-0',
          right: '$space-0',
          bottom: '$space-0',
          left: '$space-0',
        },
        '.sku-unavailable': {
          backgroundColor: '#E0E0E0',
          borderRadius: '.25rem',
          opacity: 0.5,
        },
        '.sku-text-container': {
          marginRight: 'auto',
          marginLeft: 'auto',
          paddingLeft: '1rem',
          paddingRight: '1rem',
          zIndex: 1,
        },
        '.sku-text': {
          fontSize: '14px',
          lineHeight: '20px',
          alignItems: 'center',
          textAlign: 'center',
          color: 'primary',
        },
        '.sku-text-selected': {
          color: '#134CD8',
        },
        '.sku-text-unavailable': {
          color: '#6E6E6E',
          textDecoration: 'line-through',
          opacity: 0.5,
        },
      })}
    >
      <div
        className={classnames(
          'vtex-sku-selector__item general-container',
          thumbSrc && 'vtex-sku-selector__item-image sku-thumb-container'
        )}
        onClick={handleSelect}
      >
        <div
          className={classnames(
            'sku-container',
            selected && 'sku-container-selected',
            selected || 'sku-container-not-selected'
          )}
        >
          <div
            className={classnames(
              'sku-available-action',
              isAvailable || 'sku-unavailable'
            )}
          />
          <div className={classnames(thumbSrc || 'sku-text-container')}>
            {thumbSrc ? (
              <img src={thumbSrc} alt={label} />
            ) : (
              <Text
                className={classnames(
                  'sku-text',
                  isAvailable || 'sku-text-unavailable',
                  selected && 'sku-text-selected'
                )}
              >
                {label}
              </Text>
            )}
          </div>
        </div>
      </div>
    </div>
  )
}

export default ItemSelector
